import { Component, OnInit } from '@angular/core';
import { Http, Headers } from '@angular/http';
declare var $: any;
declare var google: any;
declare var grecaptcha: any;

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  name: string;
  email: string;
  phone: string;
  department: string;
  message: string;

  constructor(private http: Http) { }

  ngOnInit() {
    LoadMap();
    LoadRecaptcha();
  }

  contactFormSubmit(form) {

    var response = grecaptcha.getResponse();

    if (response.length !== 0) {

      this.name = encodeURIComponent(form.controls.name.value);
      this.email = encodeURIComponent(form.controls.email.value);
      this.phone = encodeURIComponent(form.controls.phone.value);
      this.department = encodeURIComponent(form.controls.department.value);
      this.message = encodeURIComponent(form.controls.message.value);

      var dataToPost = "name=" + this.name + "&email=" + this.email + "&phone=" + this.phone + "&department=" + this.department + "&message=" + this.message;

      let headers = new Headers();
      headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

      this.http.post('/process.php', dataToPost, { headers: headers })
        .subscribe(
          data => data,
          error => ShowFormError(), 
          () => { ShowFormSuccess(); form.reset(); });

      grecaptcha.reset();
    }
    else {
      ShowFormRecaptchWarning();
    }
  }
}

function ShowFormRecaptchWarning() {
  $('#contactform-captcha').fadeIn();
  setTimeout(function () {
    $('#contactform-captcha').fadeOut(1000);
  }, 8000);
}

function ShowFormError() {
  $('#contactform-error').fadeIn();
  setTimeout(function () {
    $('#contactform-error').fadeOut(1000);
  }, 8000);
}

function ShowFormSuccess() {
  $('#contactform-success').fadeIn();
  setTimeout(function () {
    $('#contactform-success').fadeOut(1000);
  }, 8000);
}

function LoadRecaptcha() {
  $(document).ready(function () {
    grecaptcha.render('g-recaptcha', {
      'sitekey': '6LcNhRoTAAAAAD5JuO9yRXCjFMPLWUbmBUQqjcmL'
    });
  });
}

function LoadMap() {
  var sudburyPrint = new google.maps.LatLng(52.031938, 0.715995);

  var contactMap = new google.maps.Map(document.getElementById('contact-map'), {
    scrollwheel: false,
    navigationControl: false,
    mapTypeControl: false,
    scaleControl: false,
    draggable: true,
    center: sudburyPrint,
    zoom: 15,
    mapTypeId: google.maps.MapTypeId.ROADMAP
  });

  var marker = new google.maps.Marker({
    position: sudburyPrint,
    map: contactMap,
    title: 'Sudbury Print Group'
  });
}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts